"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.POI_REQUIRED_LISTS = void 0;
const engine_1 = require("@railgun-community/engine");
exports.POI_REQUIRED_LISTS = [
    { key: 'test', type: engine_1.POIListType.Gather },
];
